export default "__VITE_ASSET__DcPxKHQ$__"